import React from 'react'
import { Box } from 'theme-ui'
import Navigation from '../../components/Navigation/index'
import useSiteMetadata from '../../helpers/useSiteMetadata'

const styles = {
  desktopMenu: {
    display: [`none`, null, `block`]
  },
  desktopMenuWrapper: {
    justifyContent: 'flex-start',
    gap: '1rem',
  },
  navigation:{

  }
}

export const PostFooterMenu = () => {
  const { postFooterMenu } = useSiteMetadata()

  const desktopMenuNav = (
    <Navigation
      variant='horizontal'
      items={postFooterMenu}
      wrapperStyle={styles.desktopMenuWrapper}
      color='white'
      colorHover='white'
    />
  )


  return (
      <Box sx={styles.desktopMenu}>{desktopMenuNav}</Box>
  )
}
